import { PAYOUT_ACTION_TYPES } from "../../actions/payout";

const initialState = {
    payoutList: {
        totalPayout: 0,
        paidPayout: 0,
        payoutHistory: []
    },
    loading: false,
    addPayoutLoading: false,
    error: null,
    lastAddedPayout: null
};

const payoutReducer = (state = initialState, action) => {
    switch (action.type) {
        case PAYOUT_ACTION_TYPES.SET_PAYOUT_LIST:
            return {
                ...state,
                payoutList: action.payload || initialState.payoutList,
                error: null
            };

        case PAYOUT_ACTION_TYPES.CLEAR_PAYOUT_LIST:
            return {
                ...state,
                payoutList: initialState.payoutList,
                error: null,
                lastAddedPayout: null
            };

        case PAYOUT_ACTION_TYPES.SET_PAYOUT_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        case PAYOUT_ACTION_TYPES.SET_ADD_PAYOUT_LOADING:
            return {
                ...state,
                addPayoutLoading: action.payload
            };

        case PAYOUT_ACTION_TYPES.SET_PAYOUT_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false,
                addPayoutLoading: false
            };

        case PAYOUT_ACTION_TYPES.ADD_PAYOUT_SUCCESS:
            return {
                ...state,
                lastAddedPayout: action.payload,
                error: null
            };

        default:
            return state;
    }
};

export default payoutReducer;